import React from 'react';
import clsx from 'clsx';
import BrandHeader from './BrandHeader';
import LocalNavigationHeader from './localNavigation/LocalNavigationHeader';
import style from './Header.module.scss';
import ServiceLogo from '../ServiceLogo';
import ServiceMenu from './ServiceMenu';
import EnvironmentIndicator from '../EnvironmentIndicator';
import { AperzaUserProvider } from './AperzaUserContext';
import { useAperzaUser } from './UseAperzaUser';
import { AccountHeader } from './AccountHeader';
import { HeaderSearch } from './HeaderSearch';
import { MobileMenuButton } from './menulist/MobileMenuButton';
import { ResponsiveProvider } from '../util/ResponsiveContext';
import { useResponsive } from '../util/UseResponsive';
export function Header({ type, fixed, user, unreadMessageCount, children }) {
    // * Static NOTIFICATIONs
    const notifications = [
        { title: 'プライバシーポリシー改定のお知らせ', url: 'https://www.aperza.co.jp/news/%e3%83%97%e3%83%a9%e3%82%a4%e3%83%90%e3%82%b7%e3%83%bc%e3%83%9d%e3%83%aa%e3%82%b7%e3%83%bc%e6%94%b9%e5%ae%9a%e3%81%ae%e3%81%8a%e7%9f%a5%e3%82%89%e3%81%9b/' },
    ];
    const methods = useAperzaUser({ user, serviceType: type, notifications, unreadMessageCount });
    const responsiveMethods = useResponsive();
    return (React.createElement(ResponsiveProvider, { ...responsiveMethods },
        React.createElement(AperzaUserProvider, { ...methods },
            React.createElement("header", { className: clsx(style.header, { [style.fixedHeader]: fixed }) },
                React.createElement(EnvironmentIndicator, null),
                React.createElement(BrandHeader, { fixed: fixed }),
                responsiveMethods.isDesktop && (React.createElement("div", { className: style.mainHeader },
                    React.createElement(ServiceLogo, null),
                    React.createElement(ServiceMenu, null),
                    React.createElement(HeaderSearch, null),
                    React.createElement(AccountHeader, null))),
                responsiveMethods.isMobile && (React.createElement("div", { className: style.mobileMainHeader },
                    React.createElement("div", { className: style.mobileServiceRow },
                        React.createElement("div", { className: style.mobileServiceLogoWrapper },
                            React.createElement(ServiceLogo, null)),
                        React.createElement(MobileMenuButton, null)),
                    React.createElement(HeaderSearch, null))),
                React.createElement(LocalNavigationHeader, { fixed: fixed }),
                children && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: style.childWrapper }, children))),
                React.createElement("div", { className: style.headerBorder })))));
}
